import styled, { keyframes } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const Card = styled.div`
    max-width: 36rem;
    margin: 0 auto 10px auto;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 0.75rem;
    padding: 1.5rem;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const Title = styled.h3`
    font-size: 0.9rem;
    line-height: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.15rem;
    color: ${colorsPalettes.carbon[500]};
`;

export const Subtitle = styled.p`
    font-size: 0.875rem;
    color: ${colorsPalettes.carbon[300]};
    margin-bottom: 0px;
`;

export const Divider = styled.hr`
    margin-bottom: 1rem;
    border-color: ${colorsPalettes.carbon[50]};
`;

const loadingAnimation = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`;

export const StepHeader = styled.div`
    background: linear-gradient(
        270deg,
        ${colorsPalettes.blue[200]},
        ${colorsPalettes.teal[100]},
        ${colorsPalettes.blue[200]}
    );
    background-size: 600% 600%;
    animation: ${loadingAnimation} 3s ease infinite;
    padding: 0.25rem 0.75rem;
    border-radius: 0.375rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: ${colorsPalettes.carbon[500]};
`;

export const BulletList = styled.ul`
    list-style: disc;
    padding-left: 1rem;
    font-size: 0.875rem;
    color: ${colorsPalettes.carbon[500]};
    margin-bottom: 0.5rem;
`;

export const ListItem = styled.li`
    margin-bottom: 0.25rem;
`;

export const StepSection = styled.div`
    & + & {
        margin-top: 1.5rem;
    }
`;

export const Explanation = styled.p`
    font-size: 0.875rem;
    color: ${colorsPalettes.carbon[400]};
`;

const Bold = styled.span`
    font-weight: 700;
    color: ${colorsPalettes.carbon[500]};
`;

export const NewsIconWrapper = styled.span`
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid ${colorsPalettes.carbon[100]};
    margin-right: 6px;
    .SWReactIcons {
        height: 16px;
    }
    width: 24px;
    height: 24px;
`;

export const NewsTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
`;

export const NewsItemTitle = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${colorsPalettes.carbon[500]};
    width: calc(100% - 24px);
`;

export const NewsItemSnippet = styled.div`
    position: relative;
    display: flex;
    padding: 12px 16px;
    background-color: ${colorsPalettes.carbon[0]}; /* White background */
    border-radius: 8px;
    font-size: 14px;
    color: ${colorsPalettes.carbon[400]}; /* Main text color */
    line-height: 1.5;
    box-shadow: 0px 1px 3px rgba(9, 37, 64, 0.05); /* Using carbon[500] rgba variant */
    overflow: hidden;

    strong {
        font-weight: 700;
        color: ${colorsPalettes.carbon[500]}; /* Stronger color for date */
    }

    /* Left gradient border */
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(to bottom, ${colorsPalettes.teal[400]}, ${colorsPalettes.blue[400]});
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }
`;

export const Pill = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    background-color: #f5f5f5;
    border-radius: 9999px;
    font-size: 12px;
    color: #333;
    margin-top: 8px;
    text-decoration: none;
    transition: background 0.2s;

    &:hover {
        background-color: #e0e0e0;
    }
`;

export const NewsSourceContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
`;
